<div class="modal-header">
    <h4 class="modal-title pull-left">Access wallet</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="accessWalletForm">
        <div class="form-group">
            <label>Select user</label>
            <ng-select [items]="users$" bindLabel="firstName" bindValue="_id" [multiple]="true" [minTermLength]="2"
                [loading]="userLoading" class="disable-clear-all ng-clear-wrapper"
                typeToSearchText="Please enter 2 or more characters" [typeahead]="userInput$" [(ngModel)]="access"
                placeholder="Type to search user..." formControlName="access" >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span class="ng-value-label">{{item.firstName}} {{item.lastName}}</span>
                    <span class="ng-value-icon right" (click)="clear(item)">×</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div [title]="item.firstName">
                        {{item?.firstName}} {{item?.lastName}}
                    </div>
                </ng-template>
            </ng-select>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="cancel()">
        Cancel
    </button>
    <am-button (onClicked)="addAccess()" [text]="'Add Access'" [isLoading]="isButtonDisabled"></am-button>
</div>